// Filtro del sidebar por derechos de la sesión (épica #662, #649). Puro, para
// poder probarlo sin React: `can` viene de useEntitlements().
import { appKey, categoryKey } from "@torre/entitlements";
import type { AppCategory } from "./types";

/**
 * Quita las categorías y apps que la sesión no puede usar. Una categoría que se
 * queda sin apps desaparece. Si `can` dice que sí a todo (sin respuesta del
 * backend), devuelve lo mismo que recibió.
 *
 * Los mosaicos "Próximamente" se respetan: no dan acceso a nada (al tocarlos se
 * avisa que vienen en camino) y su visibilidad ya la decide el preset (en
 * producción se ocultan). El catálogo los tiene apagados por omisión, así que
 * filtrarlos aquí borraría ese aviso también en desarrollo.
 */
export function filterByEntitlements(
  categories: AppCategory[],
  can: (key: string) => boolean,
): AppCategory[] {
  return categories
    .filter((category) => can(categoryKey(category.id)))
    .map((category) => ({
      ...category,
      apps: category.apps.filter((app) => app.isComingSoon || can(appKey(app.id))),
    }))
    .filter((category) => category.apps.length > 0);
}
